import styled from "styled-components"

export const BarcodeScannerWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: #fff;
  min-height: 100dvh;
`

export const BarcodeScannerOverlay = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
`

export const EnterManuallyButtonWrapper = styled.div`
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.36);

  background: var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  backdrop-filter: blur(5.25px);

  display: flex;
  padding: 12px 20px;
  align-items: center;
  gap: 8px;

  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);

  width: 228px;
`

export const EnterManuallyText = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  color: var(--Primitive-White_100, #fff);
`
